import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { TransportsListResType } from 'src/types/transportsList';
import { getTransportsListFetchSuccess, getTransportsListFetchFailure } from './reducer';

const getTransportsListFetchRequest = async () => {
    const res = await api('get', 'api/secure/transports');
    return res.data.data;
};

function* getTransportsListFetch() {
    try {
        const response: TransportsListResType = yield call((): any => getTransportsListFetchRequest());
        yield put(getTransportsListFetchSuccess(response));
    } catch (error) {
        yield put(getTransportsListFetchFailure({ error }));
    }
}

export function* getTransportsListFetchWatch() {
    yield takeEvery('transportsList/getTransportsListFetch', getTransportsListFetch);
}
